function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34v8.5a1 1 0 01-1.191.968c-.192-.038-.509-.268-.509-.268L24 38l-7.3 5.2s-.317.23-.509.267A1 1 0 0115 42.5V28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c7.456 0 13.5-6.044 13.5-13.5S31.456 4.5 24 4.5 10.5 10.544 10.5 18 16.544 31.5 24 31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.428 18.265c-1.234-.913-.296-2.725.038-3.265-.604.668-1.208 1.324-1.67 2.044-.734 1.131-1.055 2.378-.554 3.175.9 1.44 3.047.772 4.41.193l12.7-5.36-12.546 3.316c-1.054.27-1.903.244-2.378-.103z"
  }))
};
export var MemberRewards = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    paths: compPaths,
    fill: "none"
  }));
});